




































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

import { Organization } from '@/common/Organizations';

import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import RadioField from '@/components/Form/RadioField.vue';

@Component({
	name: 'TabProfile',
	components: {
		TextField,
		SwitchField,
		RadioField,
	},
})
export default class TabProfile extends Vue {
	@Prop() public $v: any;
	@Prop() private user: any;

	@State('organizations', { namespace: 'Organizations' })
	private organizations: Organization[] = undefined;

	private orgId: string = this.user.org_id;

	get organizationList() {
		return this.organizations
			.filter(org => org.org_name !== undefined)
			.map(org => {
				if (org.is_agency === true) {
					org.org_name = org.org_name.replace(/\(Agency\)/, '').trim() + ' (Agency)';
				}
				return {
					org_id: org.org_id,
					org_name: org.org_name,
				};
			});
	}

	private updateOrg(value) {
		this.user.org_id = value;
		this.orgId = value;
	}
}
